"use client";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "./ui/use-toast";

export default function ApplicationCareer({ careerDesc }) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [loading, setLoading] = useState(false);

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      // Create FormData for file upload
      const formData = new FormData();
      formData.append("file", data.resume[0]);

      // Upload resume to Supabase
      const uploadResponse = await fetch("/api/resume", {
        method: "POST",
        body: formData,
      });

      console.log(uploadResponse);

      if (!uploadResponse.ok) {
        setLoading(false);
        return toast({
          title: "Something went wrong.",
          description: "Please refresh the page and try again.",
          variant: "destructive",
        });
      }

      const uploadData = await uploadResponse.json();
      const resumeUrl = uploadData.fullPath;

      console.log(resumeUrl);

      // Submit application with resume URL
      const applicationData = {
        name: `${data.firstName} ${data.lastName}`,
        email: data.email,
        phone: data.phone,
        resume: `https://oywpvgohpcilccbzsznm.supabase.co/storage/v1/object/public/${resumeUrl}`,
        job_id: careerDesc.id,
      };

      const applicationResponse = await fetch("/api/applications", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(applicationData),
      });

      if (!applicationResponse.ok) {
        setLoading(false);
        return toast({
          title: "Already Applied",
          description: "Please refresh the page and try again.",
          variant: "destructive",
        });
      }
      setLoading(false);
      return toast({
        title: "Application submitted successfully!",
        description: "We will get back to you soon.",
        variant: "success",
      });
    } catch (error) {
      console.error("Failed to submit application:", error);
      setLoading(false);
      return toast({
        title: "Already Applied!",
        description: "Please refresh the page and try again.",
        variant: "destructive",
      });
    }
  };

  return (
    <form className="p-2 bg-white space-y-4" onSubmit={handleSubmit(onSubmit)}>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-gray-700 mb-4 text-sm">
            First Name*
          </label>
          <input
            type="text"
            placeholder="Enter..."
            className="text-sm w-full py-2 px-4 bg-white border border-gray-300 rounded-lg focus:outline-none mt-1"
            {...register("firstName", { required: true })}
          />
        </div>
        <div>
          <label className="block text-sm text-gray-700 mb-4">Last Name*</label>
          <input
            type="text"
            placeholder="Enter..."
            className="w-full text-sm py-2 px-4 bg-white border border-gray-300 rounded-lg focus:outline-none mt-1"
            {...register("lastName", { required: true })}
          />
        </div>
      </div>

      <label className="block text-sm text-gray-700 mt-4">Email Address*</label>
      <input
        type="email"
        placeholder="Email Address"
        className="w-full text-sm py-2 px-4 bg-white border border-gray-300 rounded-lg focus:outline-none mt-1"
        {...register("email", { required: true })}
      />

      <label className="block text-sm text-gray-700 mt-4">Phone Number*</label>
      <input
        type="tel"
        placeholder="Phone Number"
        className="w-full text-sm py-2 px-4 bg-white border border-gray-300 rounded-lg focus:outline-none mt-1"
        {...register("phone", { required: true })}
      />

      <label className="block text-sm text-gray-700 mt-4">Upload Resume*</label>
      <input
        type="file"
        accept=".doc,.pdf"
        className="w-full text-sm py-2 px-4 bg-white border border-gray-300 rounded-lg focus:outline-none mt-1"
        {...register("resume", { required: true })}
      />

      <button
        type="submit"
        className="w-full py-2 bg-black text-white rounded-lg focus:outline-none mt-4"
      >
        {loading ? "Submitting..." : "Submit Application"}
      </button>
    </form>
  );
}
